module.exports = __webpack_public_path__ + "img/arrows-white.a062addb.png";